export default __webpack_public_path__ + "static/media/googleplay.9998b72e.svg";